import { useEffect } from "react";

export default function GoogleTranslate() {
  /*global google*/
//console.log(Object.L);
const googleTranslateElementInit = () => {
       new window.google.translate.TranslateElement(
         {
           pageLanguage: 'en',
           autoDisplay: false,
           includedLanguages: 'en,es,fr,ht,ko,pt,vi,zh-CN'
         },
         'google_translate_element'
       )
    }
useEffect(() => {
  var addScript = document.createElement("script");
  addScript.setAttribute(
     "src",
     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
   );
   document.body.appendChild(addScript);
   window.googleTranslateElementInit = googleTranslateElementInit;
}, [])
  return(
    <>
         <div id="google_translate_element"></div>
    </>
  );
}
